import React from "react";
import { SignedOut, SignInButton, SignUpButton } from "@clerk/clerk-react";
import "./TopRightAuth.css";

export default function TopRightAuth() {
    return (
        <SignedOut>
            <div className="top-right-auth">
                <SignInButton mode="modal">
                    <button className="auth-btn log-in-btn">Log in</button>
                </SignInButton>
                <SignUpButton mode="modal">
                    <button className="auth-btn sign-up-btn">Sign up for free</button>
                </SignUpButton>
            </div>
        </SignedOut>
    );
}
